<template>
  <div class="tutorial-page">
    <h2 class="title">{{ title }}</h2>
    <div class="carousel">
      <div class="button-back">
        <button v-if="!isFirstPage" class="btn" @click="backClicked"><span>	&lt;</span></button>
      </div>
      <div class="image">
        <HealthyTutorialBuddy v-if="showBuddy" :buddy="buddy"></HealthyTutorialBuddy>
        <img :src="image" alt="">
        <UnhealthyTutorialBuddy v-if="showBuddy" :buddy="buddy"></UnhealthyTutorialBuddy>

      </div>

      <div class="button-forward">
        <button v-if="!isLastPage" class="btn" @click="forwardClicked"><span>&gt;</span></button>
      </div>
    </div>
    <p class="body">
      {{ body }}
    </p>
  </div>

</template>

<script>

import UnhealthyTutorialBuddy from "@/components/StudentPlatform/Onboarding/UnhealtyTutorialBuddy";
import HealthyTutorialBuddy from "@/components/StudentPlatform/Onboarding/HealthyTutorialBuddy";

export default {
  name: "TutorialPage",
  components: { UnhealthyTutorialBuddy, HealthyTutorialBuddy },
  props: {
    title: String,
    body: String,
    image: String,
    isFirstPage: Boolean,
    isLastPage: Boolean,
    buddy: Object,
    showBuddy: Boolean,
  },
  data()
  {
    return {}
  },
  computed: {},
  mixins: [],
  methods: {
    backClicked()
    {
      this.$emit("backClicked");
    },

    forwardClicked()
    {
      this.$emit("forwardClicked");
      }
    },
    mounted() {

    },
    created() {
    },
  }


</script>

<style lang="scss" scoped>

  .tutorial-page {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;


    .title {
      color: white;
      font-size: 1.5rem;
      text-align: center;
      margin-bottom: 20px;
    }

    .carousel {
      height: 40%;
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;


      .button-back, .button-forward {
        //width: 15%;
        width: 90px;
        //height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        button {
          width: 50px;
          height: 50px;
          //background-image: url("~@/assets/image/platform/icons/icon_back.svg");
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center center;

          span {
            color: white;
            font-size: 3rem;
            line-height: 0.5;
          }
        }

      }

      .button-forward {
        button {
          // transform: rotate(180deg);
        }
      }

      .image {
        //width: 70%;
        //height: 100%;
        //content is now fixed to allow the use of the user's buddy in tutorial images
        width: 420px;
        height: 210px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
        }
      }

    }

    .body {
      height: 30%;
      margin-left: 15%;
      margin-right: 15%;
      //overflow: scroll;
      color: white;
    }
  }

</style>